import { axiosInstance } from '../../../api/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import APIEndpoints from '../../../Member/api/APIEndpoints';

export const setAdminConfig = createAsyncThunk(
  'setAdminConfig',
  async (params, { getState }) => {
    const response = await axiosInstance.get(
      APIEndpoints.getAdminConfigResources(),
    );
    return response.data;
  },
);
export const setEmailConfig = createAsyncThunk(
  'setEmailConfig',
  async (params, { getState }) => {
    const response = await axiosInstance.get(
      APIEndpoints.getClientEmailConfiguration(),
    );
    return response?.data?.Response?.Clientconfiguration?.configuration;
  },
);
